import Crud from '../views/TipoAuxilioLocomocao/Crud'
import Entity from '../views/TipoAuxilioLocomocao/Add'

let routes = {
    path: '/tipo_auxilio_locomocao',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_auxilio_locomocao/add',
            name: 'NovoAuxilio',
            component: Entity
        },
        {
            path: '/tipo_auxilio_locomocao/edit/:id?',
            name: 'EditarAuxilio',
            component: Entity
        },
        {
            path: '/tipo_auxilio_locomocao',
            name: 'list-tipo-auxilio-locomocao',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Auxilios Locomoções',
                breadcrumb: [
                    {
                        text: 'Tipos de Auxilios Locomoções',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
